/**
 * What the verification screens know about a case, a plan and a campaign that the
 * registry does not say: how the long text fields group on the detail form, and
 * which fields the New dialog asks for up front (issues #105, #106).
 *
 * Which fields a KIND has is the server's answer (`types[].fields`, `statable`);
 * this only orders and groups what it sends.
 */

export type VerificationGroup = 'case' | 'plan' | 'campaign'

/** The sections of the detail form, in the order a procedure is run. */
export const VERIFICATION_SECTIONS: { title: string; fields: string[] }[] = [
  { title: 'Setup', fields: ['test_conditions', 'test_input', 'hardware', 'instrumentation', 'safety'] },
  { title: 'Execution', fields: ['data_reduction'] },
  { title: 'Results', fields: ['test_output', 'pass_fail_criteria', 'test_notes'] },
]

/** The fields that hold paragraphs, so their boxes are multi-line. */
export const LONG_TEXT_FIELDS = new Set(VERIFICATION_SECTIONS.flatMap((section) => section.fields))

/** What the New dialog asks for before it collapses the rest. */
export const MAIN_FIELDS: Record<VerificationGroup, string[]> = {
  case: ['verifies', 'method', 'statement'],
  plan: ['statement', 'stand'],
  campaign: ['statement'],
}

/** Fields the dialog asks for in its own words, or the server derives. */
export const ASKED_ELSEWHERE = new Set(['name', 'identifier', 'type_name', 'owner', 'is_illustrative'])

/** The parent kind a group of verification element may sit inside, if any. */
export const PARENT_GROUP: Record<VerificationGroup, VerificationGroup | null> = {
  case: 'plan',
  plan: 'campaign',
  campaign: null,
}

export const GROUP_LABEL: Record<VerificationGroup, string> = {
  case: 'Test case',
  plan: 'Test plan',
  campaign: 'Test campaign',
}
